import { SET_MODO_PRODUCAO, SET_MODO_REPOSICAO } from '../actions/actionTypes';
import { modoOperacao } from '../utils/Constants';

const initialState = {
    modo: modoOperacao.PRODUCAO,
};

export const modoOperacaoReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MODO_PRODUCAO:
            return {
                ...state,
                modo: modoOperacao.PRODUCAO,
            };
        case SET_MODO_REPOSICAO:
            return {
                ...state,
                modo: modoOperacao.REPOSICAO,
            };
        default:
            return state;
    }
};
